import { useEffect, type ReactNode } from 'react';
import { applyAppearanceMotion } from './applyAppearanceMotion';
import { useAppearanceSettingsStore } from './appearance-settings.store';

export function AppearanceMotionProvider({ children }: { children: ReactNode }) {
  const animationsEnabled = useAppearanceSettingsStore((s) => s.animationsEnabled);

  useEffect(() => {
    applyAppearanceMotion({ animationsEnabled });
  }, [animationsEnabled]);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      const enabled = useAppearanceSettingsStore.getState().animationsEnabled;
      applyAppearanceMotion({ animationsEnabled: enabled });
    };
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return <>{children}</>;
}
